import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Helmet from "react-helmet";
// import TeamImage from './TeamImage.png'
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { SocialView } from "../SocialView/SocialView";
import { FooterNote } from "../FooterLinks/FooterNote";
import { ProgramView } from "./ProgramView";

import {
  fetchMenusIfNeeded,
  fetchMoviesFromFestivalIfNeeded,
  fetchCitiesIfNeeded,
  CLIENT_BASE_URL
} from "../../actions";

export class ProgramFullView extends React.Component {
  componentWillMount(p) {
    const { dispatch } = this.props;
    dispatch(fetchCitiesIfNeeded());
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
  }

  componentWillReceiveProps(nextProps) {
    const { match, dispatch, selectedCity } = nextProps;
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope));
    }

    if (nextProps.selectedCity !== selectedCity) {
      dispatch(fetchMoviesFromFestivalIfNeeded(selectedCity));
    }
  }

  render() {
    const { menus, dispatch } = this.props;
    const bottom_menus = menus.bottom || [];
    const top_menus = menus.top || [];

    return (
      <div>
        <Helmet
          title="Programação"
          meta={[
            {
              name: "description",
              content:
                "A Festa do Cinema Italiano é o acontecimento mais importante em Portugal dedicado à cultura italiana e um dos festivais cinematográficos mais apreciados no país. Organizado pela Associação Il Sorpasso desde 2008, a Festa do Cinema Italiano ampliou também a sua presença internacionalmente com extensões e programação a decorrer em países como Brasil, Angola e Moçambique."
            },
            {
              property: "og:image",
              content:
                "https://festadocinemaitaliano.com/admin/assets/img/FCI_12a_branco.png"
            },
            { property: "og:title", content: "Programação" },
            { property: "og:type", content: "article" },
            {
              property: "og:url",
              content: CLIENT_BASE_URL + "/programacao"
            }
          ]}
        />
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="program-full-view" className="team-view">
          <div className="row">
            <div className="col-md-12 no-pad text-left">
              <p className="left-tag">Programação</p>
            </div>
          </div>
          <div className="main-block">
            <ProgramView {...this.props} />
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus} />
        <SocialView customclass="lite" />
        <FooterNote />
      </div>
    );
  }
}

ProgramFullView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  menus: PropTypes.any.isRequired,
  selectedScope: PropTypes.string.isRequired,
  selectedCity: PropTypes.string.isRequired,
  city_movies: PropTypes.object.isRequired,
  isFetchingMovieCity: PropTypes.bool.isRequired,
  cities: PropTypes.array.isRequired,
  isFetchingCities: PropTypes.bool.isRequired,
  selectedDay: PropTypes.string.isRequired,
  selectedAgendaColor: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  const {
    getMenus,
    selectedScope,
    selectedCity,
    selectedDay,
    getAllCities,
    getMoviesFromFestival,
    selectedAgendaColor
  } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const {
    isFetchingMovieCity,
    lastUpdatedCity,
    events: city_movies,
    numPastEvents
  } = getMoviesFromFestival[selectedCity] || {
    isFetchingMovieCity: true,
    items: {}
  };

  const { isFetchingCities, items: cities } = getAllCities["all"] || {
    isFetchingCities: true,
    items: []
  };

  return {
    isFetchingMenus,
    isFetchingMovieCity,
    isFetchingCities,
    lastUpdatedMenus,
    menus,
    selectedScope,
    selectedDay,
    selectedCity,
    city_movies,
    cities,
    lastUpdatedCity,
    selectedAgendaColor,
    numPastEvents
  };
}

export default connect(mapStateToProps)(ProgramFullView);



// WEBPACK FOOTER //
// ./src/views/ProgramView/ProgramFullView.js